import { APPT_STATUS } from "@/lib/constants";

export const StatusBadge = ({ status }) => {
  const s = APPT_STATUS[status] || { label: status, token: "--muted-foreground" };
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{
        color: `hsl(var(${s.token}))`,
        backgroundColor: `hsl(var(${s.token}) / 0.12)`,
        border: `1px solid hsl(var(${s.token}) / 0.3)`,
      }}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: `hsl(var(${s.token}))` }} />
      {s.label}
    </span>
  );
};
